/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
    window.hideStickySearch = function() {
        document.body.classList.add('scroll-search-removed');
    }

    let lastScrollTop = 0;
    window.addEventListener("scroll", function() {
        // Read CSS variable --pm-hero-height
        const heroHeight = parseInt(
            getComputedStyle(document.body)
                .getPropertyValue("--pm-hero-height")
                .trim(),
            10
        );

        const st = window.pageYOffset || document.documentElement.scrollTop;


        if (st > lastScrollTop) {
            // scrolling down
            document.body.classList.remove("scrolled-up");
            document.body.classList.add("scrolled-down");
        } else if (st < lastScrollTop) {
            // scrolling up
            document.body.classList.remove("scrolled-down");
            document.body.classList.add("scrolled-up");
        }

        // If scroll is less than hero height, remove both classes
        if (st < heroHeight) {
            document.body.classList.remove("scrolled-up", "scrolled-down");
            lastScrollTop = st;
            return;
        }
        lastScrollTop = st <= 0 ? 0 : st; // avoid negative values
    }, false);
})();

(function() {

    function syncSelectsByName(name) {
        const selects = document.querySelectorAll(`select[name="${name}"]`);

        selects.forEach(select => {
            select.addEventListener("change", e => {
                const value = e.target.value;

                // Update all other selects in the group
                selects.forEach(other => {
                    if (other !== e.target) {
                        other.value = value;
                    }
                });
            });
        });
    }
    document.addEventListener("DOMContentLoaded", () => {
        syncSelectsByName('selling_plan');
    });

    // Product form logic (variant selection, availability, subscription plans,
    // gallery sync) is handled by the pmd-* web components in pmd-components.js
    // (see blocks/pm-product-form.liquid).

    async function addToCart(params) {
        const {
            id,
            quantity = 1,
            selling_plan,
            properties,
        } = params;

        const item = {
            id: id,
            quantity,
            ...(selling_plan && { selling_plan: selling_plan }),
            ...(properties && Object.keys(properties).length > 0 && { properties }),
        };

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({ items: [item] }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(`Add to cart failed: ${error.description || response.statusText}`);
        }

        return response.json();
    }
    window.pmAddToCart = addToCart;

    document.addEventListener('click', async (e) => {
        const el = e.target.closest('[data-pm-add-to-cart]');
        if (!el) return;
        e.preventDefault();

        const id = parseInt(el.getAttribute('data-pm-add-to-cart'), 10);

        try {
            await addToCart({
                id
            });
        } catch (err) {
            console.error('❌ ATC error:', err);
        }
    });

    function trackScrollGlobally(selector, callback) {
        const checkScroll = () => {
            document.querySelectorAll(selector).forEach(el => {
                const hasScroll =
                    el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
                callback(el, hasScroll);
            });
        };

        // Initial check after DOM ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', checkScroll);
        } else {
            checkScroll();
        }

        // Re-check on resize
        window.addEventListener('resize', checkScroll);

        // Re-check when new elements are added
        new MutationObserver(checkScroll).observe(document.body, {
            childList: true,
            subtree: true,
        });
    }


    /**
     * Code to watch of elements height change, can be usable when you need to track something
     * just add data-css-height attribute to element you want to track height, use names like this:
     * body:some-name - will add css var --some-name: <height>px to body
     * el:some-name - will add css var --some-name: <height>px to element itself
     */
    function applyCssHeightSync() {
        const targets = document.querySelectorAll('[data-css-height]');

        targets.forEach(el => {
            const attr = el.getAttribute('data-css-height');
            const [target, key] = attr.split(':');

            if (!key || (target !== 'body' && target !== 'el')) return;

            const height = el.offsetHeight + 'px';

            if (target === 'body') {
                document.body.style.setProperty(`--${key}`, height);
            } else {
                el.style.setProperty(`--${key}`, height);
            }
        });
    }

    applyCssHeightSync();
    window.addEventListener('resize', applyCssHeightSync);

    document.addEventListener('click', (event) => {
        document.querySelectorAll('[data-click-outside]').forEach(el => {
            if (el.contains(event.target)) return;

            const value = el.getAttribute('data-click-outside');
            if (!value || !value.includes(':')) return;

            const [selector, className] = value.split(':');

            if (selector === 'self') {
                el.classList.remove(className);
            } else {
                const target = document.querySelector(selector);
                if (target && !target.contains(event.target)) {
                    target.classList.remove(className);
                }
            }
        });
    });


    /**
     * Toggle class on click on element
     * Usage: data-toggle-for="<selector>:<class>"
     */
    function closest(el, selector, stop) {
        while (el) {
            if (el.hasAttribute(stop)) return null;
            if (el.hasAttribute(selector)) return el;
            el = el.parentElement;
        }

        return null;
    }

    document.addEventListener('click', (event) => {
        const button = closest(event.target, 'data-toggle-for', 'data-toggle-stop');
        if (!button) return;

        const [selector, className] = button.dataset.toggleFor.split(':');
        const target = document.querySelector(selector);

        if (target && className) {
            target.classList.toggle(className);
        }
    });

    const classTriggerRegistry = new Map();

    const parseClassMap = (attr) => {
        return Object.fromEntries(
            attr.split(',').map(pair => pair.trim().split(':'))
        );
    };

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') continue;

            const el = mutation.target;
            const attr = el.getAttribute('data-class-added');
            if (!attr) continue;

            const map = classTriggerRegistry.get(el) || parseClassMap(attr);
            classTriggerRegistry.set(el, map);

            const oldClassList = new Set((mutation.oldValue || '').split(/\s+/));
            const newClassList = new Set(el.classList);

            for (const cls in map) {
                if (!oldClassList.has(cls) && newClassList.has(cls)) {
                    const fn = window[map[cls]];
                    if (typeof fn === 'function') fn.call(el);
                }
            }
        }
    });

    observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['class']
    });


    if (!customElements.get('slider-carousel'))
        customElements.define('slider-carousel', class extends HTMLElement {
            connectedCallback() {
                requestAnimationFrame(() => this.initWhenReady());
            }

            updateSlideOffsets() {
                this.slideOffsets = this.slides.map(slide => slide.offsetLeft);
            }


            onScrollEnd() {
                clearTimeout(this._scrollTimeout);
                this._scrollTimeout = setTimeout(() => {
                    this.updateSlideOffsets(); // recalc in case layout shifted
                    const scrollLeft = this.scrollLeft;
                    const distances = this.slideOffsets.map(offset => Math.abs(offset - scrollLeft));
                    const closestIndex = distances.indexOf(Math.min(...distances));
                    this.currentIndex = closestIndex;
                    this.dispatchEvent(new CustomEvent('slidechange', { detail: { index: closestIndex } }));

                    const atRight = this.scrollLeft + this.clientWidth >= this.scrollWidth;
                        this.classList.toggle('scrolled-to-end', atRight);
                }, 100);
            }


            scrollToSlide(index) {
                const target = this.slides[index];
                if (!target) return;

                const container = this;

                const containerRect = container.getBoundingClientRect();
                const targetRect = target.getBoundingClientRect();

                const offset = targetRect.left - containerRect.left + container.scrollLeft;

                container.scrollTo({
                    left: offset,
                    behavior: 'smooth'
                });
            }

            nextSlide() {
                if (this.currentIndex < this.slides.length - 1) {
                    this.currentIndex++;
                    this.scrollToSlide(this.currentIndex);
                }
            }

            prevSlide() {
                if (this.currentIndex > 0) {
                    this.currentIndex--;
                    this.scrollToSlide(this.currentIndex);
                }
            }



            initWhenReady() {
                this.slides = Array.from(this.querySelectorAll('.slide'));
                this.updateSlideOffsets();
                this.currentIndex = 0;
                const slidesToShow = this.dataset.slides;
                const gap = parseInt(this.dataset.gap || '16');
                this.style.gap = `${gap}px`;

                if (slidesToShow === 'auto') {
                    this.style.gridAutoColumns = 'max-content';
                } else {
                    const count = parseFloat(slidesToShow || '1');
                    const totalGap = gap * (count - 1);
                    const columnWidth = `calc((100% - ${totalGap}px) / ${count})`;
                    this.style.gridAutoColumns = columnWidth;
                }
                this.addEventListener('scroll', this.onScrollEnd.bind(this));



                let isDown = false, startX, scrollLeft;
                let isDragging = false;

                this.addEventListener('mousedown', e => {
                    isDown = true;
                    isDragging = false;

                    startX = e.pageX - this.offsetLeft;
                    scrollLeft = this.scrollLeft;
                });
                this.addEventListener('mouseleave', () => isDown = false);
                this.addEventListener('mouseup', (e) => {
                    isDown = false;
                    this.classList.remove('dragging');

                    if (isDragging)
                        e.preventDefault();
                });
                this.addEventListener('mousemove', e => {
                    if (!isDown) return;
                    if (Math.abs(e.clientX - startX) > 5) {
                        isDragging = true;
                        this.classList.add('dragging');
                    }

                    e.preventDefault();
                    const x = e.pageX - this.offsetLeft;
                    const walk = (x - startX) * 1.5;
                    this.scrollLeft = scrollLeft - walk;
                });

                const group = this.dataset.group;
                const role = this.dataset.role;

                
                if (role === 'main') {
                    const localGroup = this.dataset.group;
                    const localRole = this.dataset.role;

                    window.addEventListener('pm:slide-select', e => {
                        if (e.detail.group !== localGroup || e.detail.role === localRole) return;
                        const targetIndex = e.detail.index;
                        const slideWidth = this.querySelector('.slide')?.offsetWidth || 0;
                        this.scrollTo({ left: targetIndex * (slideWidth + gap), behavior: 'smooth' });
                    });
                }

                if (role === 'thumbs') {
                    this.querySelectorAll('.slide').forEach((slide, index) => {
                        slide.addEventListener('click', (e) => {

                            if (isDragging) return;

                            this.querySelectorAll('.slide').forEach((slide) => {
                                slide.classList.remove('active');
                            });

                            slide.classList.add('active');

                            slide.dispatchEvent(new CustomEvent('pm:slide-select', {
                                detail: { slide, index, group, role },
                                bubbles: true
                            }));
                        });
                    });
                    const localGroup = this.dataset.group;
                    const localRole = this.dataset.role;

                    window.addEventListener('pm:slide-select', e => {
                        if (e.detail.group !== localGroup || e.detail.role === localRole) return;
                        const targetIndex = e.detail.index;
                        const slideWidth = this.querySelector('.slide')?.offsetWidth || 0;
                        this.scrollTo({ left: targetIndex * (slideWidth + gap), behavior: 'smooth' });
                    });
                }

                if (role === 'main') {
                    let lastIndex = -1;
                    const slides = this.querySelectorAll('.slide');
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                const index = [...slides].indexOf(entry.target);
                                if (index !== lastIndex) {
                                    lastIndex = index;
                                    entry.target.dispatchEvent(new CustomEvent('pm:slide-select', {
                                        detail: { index, group, role },
                                        bubbles: true
                                    }));
                                }
                            }
                        });
                    }, {
                        root: this,
                        threshold: 1
                    });

                    slides.forEach(slide => observer.observe(slide));
                }

            }
        });

    if (!customElements.get('slider-control'))
        customElements.define('slider-control', class extends HTMLElement {
            connectedCallback() {
                this.addEventListener('click', (event) => {
                    const direction = this.getAttribute('data-direction');
                    const group = this.getAttribute('data-group');

                    const slider = document.querySelector(`slider-carousel[data-group="${group}"]`);
                    
                    if (!slider) return;

                    if (direction === 'prev' && typeof slider.prevSlide === 'function') {
                        slider.prevSlide();
                    } else if (direction === 'next' && typeof slider.nextSlide === 'function') {
                        slider.nextSlide();
                    }
                });
            }
        });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


(function() {
    const _fetch = window.fetch;
    const _registry = new Set();

    window.fetch = function(input, init) {
        const url = typeof input === 'string' ? input : input?.url ?? '';
        const promise = _fetch.apply(this, arguments);

        _registry.forEach(badge => {
            const handle = badge.getAttribute('handle');
            if (!handle || !url.includes(handle)) return;

            promise.then(response => {
                const clone = response.clone();
                clone.json().then(data => {
                    badge.data = data;
                    badge.setAttribute('data', JSON.stringify(data));
                    if (typeof badge.render === 'function') badge.render(data);
                }).catch(() => {
                    clone.text().then(text => {
                        badge.data = text;
                        badge.setAttribute('data', text);
                        if (typeof badge.render === 'function') badge.render(text);
                    });
                });
            });
        });

        return promise;
    };

    const _badges = new Set();
    if (!customElements.get('pmd-suppco-badge'))
        customElements.define('pmd-suppco-badge', class extends HTMLElement {
            connectedCallback() {
                _registry.add(this);

                if (!_badges.has(this)) {
                    _badges.add(this);

                    this.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log(`Clicking on badge for product: ${this.data.product.slug}`, this);
                        document.querySelector(`[data-original-href="https://supp.co/products/${this.data.product.slug}"]`)?.click();
                    });

                    // Only reachable where the markup makes the badge focusable (role="button" tabindex="0").
                    this.addEventListener('keydown', (e) => {
                        if (e.key !== 'Enter' && e.key !== ' ') return;
                        e.preventDefault();
                        this.click();
                    });
                }
            }
            disconnectedCallback() {
                _registry.delete(this);
            }

            render(data) {
                if (data && data.success) {
                    this.innerHTML = `
                        <span class="dot"></span>
                        <span class="score">${Number(data.product.product_trust_score).toFixed(2)}</span>
                        <span class="label"></span>
                    `;
                    // Optional label="" attribute (set from theme settings); text only, never markup.
                    this.querySelector('.label').textContent = this.getAttribute('label') || 'Trust Score™';
                }
                this.setAttribute('state', 'rendered')
            }
        });
})();

/*
* Zoww geolocation auto-redirect fix.
*
* The app renders its own hardcoded <input name="return_to" value="/"> into the
* Shopify localization form. When the app geo-detects a country that differs from
* the active market it submits that form, and Shopify honours the LAST return_to,
* so any visitor whose geo does not match the market is bounced to the homepage
* instead of staying on the page they landed on.
*
* Collapse the field down to a single input pointing at the current page. The
* input to keep is chosen by value, never by position, so a markup reorder in a
* future version of the app cannot make this drop the correct one.
*/
(function() {
    function normalizeReturnTo() {
        var form = document.querySelector('zoww-auto-redirect-form form#localization_form');
        if (!form) return false;

        var inputs = form.querySelectorAll('input[name="return_to"]');
        if (!inputs.length) return true;

        var currentPath = window.location.pathname + window.location.search;
        var keep = null;

        // Prefer an input that already points at this page, whichever one that is.
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value === currentPath) {
                keep = inputs[i];
                break;
            }
        }

        // Otherwise keep the first and correct it, rather than trusting any of them.
        if (!keep) {
            keep = inputs[0];
            keep.value = currentPath;
        }

        for (var j = 0; j < inputs.length; j++) {
            if (inputs[j] !== keep) inputs[j].remove();
        }

        return true;
    }

    if (!normalizeReturnTo()) {
        document.addEventListener('DOMContentLoaded', normalizeReturnTo);
    }
})();
